import { AnyAction } from 'redux'
import {
  actionTypeWrapper,
  LoadingTypes,
  startLoading,
  stopLoading,
} from '@labrav/common'

import type { AppDispatch, RootState } from '../../store/types'
import type { CloudMarketplace } from '../productsListing/types'
import { FlyoutFunction } from '../productsListing/types'
import { setSelectedProductOnListing } from '../productsListing/action'
import { ProductListingFilterType } from './types'
import { CloudProductFilterConstructor } from './utils'

export { ProductListingFilterType }
export { getProductFilterListData } from './utils/getProductFilterListData'
export { getFlyoutProductsListBasedOnFunction } from './utils/getFlyoutProductsListBasedOnFunction'
export { CloudProductFilterConstructor } from './utils/CloudProductFilterConstructor'
export type { CloudProductFiltersFunctionType } from './types'

export const setCloudMarketplaceProductListing = (cloud: CloudMarketplace) => ({
  type: ProductListingFilterType.SET_CLOUD_MARKETPLACE,
  payload: cloud,
})

export const setCreatePrivateOfferModalOpen = (open: boolean) => ({
  type: ProductListingFilterType.SET_CREATE_PRIVATE_OFFER_MODAL_OPEN,
  payload: open,
})

export const updateProductIdOnFilters =
  (
    productId: string,
    cloudType: CloudMarketplace,
    functionType?: FlyoutFunction
  ) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    if (functionType) {
      const cloudFilter = CloudProductFilterConstructor(functionType)
      await dispatch(cloudFilter().clearData() as unknown as AnyAction)
      await dispatch(cloudFilter().setPageAsOne() as unknown as AnyAction)
    }
    await dispatch(startLoading(LoadingTypes.GENERAL))
    await dispatch(
      actionTypeWrapper(cloudType, setSelectedProductOnListing(productId))
    )
    await dispatch(stopLoading(LoadingTypes.GENERAL))
  }
